/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular.module("uCountitUiApp").config(function ($stateProvider) {
  $stateProvider.state("app.footfall", {
    url: "/footfall/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      switch ($stateParams.orgType) {
        case "store":
          return "app/content/footfall/storedetail.html"
        case "sensor":
          return "app/camera/detail/cameradetail.html"
        default:
          return "app/store/comparison/storecomparison.html"
      }
    },

    controllerProvider($stateParams) {
      switch ($stateParams.orgType) {
        case "store":
          return "StoreDetailCtrl"
        case "sensor":
          return "CameraDetailCtrl"
        default:
          return "StoreComparisonCtrl"
      }
    },
  })

  $stateProvider.state("app.genderAge", {
    url: "/gender-age/:orgType/:id?from&to",
    templateUrl: "app/content/gender-age/gender-age.html",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    controller: "GenderAgeSearchCtrl",
  })

  $stateProvider.state("app.heatmap", {
    url: "/heatmap/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "app/content/heatmap/storeheatmap.html"
      } else {
        return "app/content/store-only.html"
      }
    },
    controllerProvider($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "StoreHeatmapCtrl"
      } else {
        return null
      }
    },
  })

  $stateProvider.state("app.tracking-tree", {
    url: "/tracking-tree/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      if (["sensor"].includes($stateParams.orgType)) {
        return "app/content/tracking-tree/trackingtree.html"
      } else {
        return "app/content/sensor-only.html"
      }
    },
    controller: "TrackingTreeCtrl",
  })

  $stateProvider.state("app.path-tree", {
    url: "/path-tree/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      if (["store"].includes($stateParams.orgType)) {
        return "app/content/path-tree/path-tree.html"
      } else {
        return "app/content/store-only.html"
      }
    },
    controller: "PathTreeCtrl",
  })

  $stateProvider.state("app.zonetraffic", {
    url: "/zonetraffic/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "app/content/zonetraffic/zonetraffic.html"
      } else {
        return "app/content/store-only.html"
      }
    },
    controllerProvider($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "ZoneTrafficCtrl"
      } else {
        return null
      }
    },
  })

  $stateProvider.state("app.occupancy", {
    url: "/occupancy/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "app/content/occupancy/occupancy.html"
      } else {
        return "app/content/store-only.html"
      }
    },
    controllerProvider($stateParams) {
      if (["store", "sensor"].includes($stateParams.orgType)) {
        return "OccupancyCtrl"
      } else {
        return null
      }
    },
  })

  return $stateProvider.state("app.directionmap", {
    url: "/directionmap/:orgType/:id?from&to",
    params: {
      from: {
        dynamic: true,
      },
      to: {
        dynamic: true,
      },
    },
    templateUrl: "app/content/directionmap/directionmap.html",
    controller: "DirectionmapCtrl",
  })
})
